import { InputConfig } from "@cpj-ai/panel-npm-package";

export const inputConfigs: InputConfig[] = [
  {
    name: "email",
    previewSize: 12,
    inputProps: {
      type: "text",
      label: "Organization Email",
      placeholder: "Ex : admin@cpj.com",
    },
    rules: {
      required: "This field is required",
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: "Invalid email address",
      },
    },
  },
];
